import React from "react";
import Moment from "react-moment";

interface DateColumnProps {
  date: number | Date;
  type: "short" | "long";
}

export const DateColumn = ({ date, type }: DateColumnProps) => {
  const dateFormatted = Number(date) ? Number(date) * 1000 : date;
  switch (type) {
    case "short":
      return (
        <Moment format="DD/MM/YYYY" className="date-column">
          {dateFormatted}
        </Moment>
      );
    case "long":
      return (
        <Moment format="MMM D, LT" className="date-column">
          {dateFormatted}
        </Moment>
      );
  }
};
